import React from 'react';
import { CFormControlPassword } from './control.password';

const CFormControl = {
    Password : function(props) {return <CFormControlPassword {...props} /> }
}

export default CFormControl